__turbopack_context__.v({
  "searchTitle": "ugGkuG_searchTitle",
  "suggestedSearch": "ugGkuG_suggestedSearch",
  "suggestedSearchButton": "ugGkuG_suggestedSearchButton",
  "titleFont": "ugGkuG_titleFont",
});
